export default __webpack_public_path__ + "3d5740bce0b4397cac1eec7a56730395.png";